const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  loginView: "",
};

const loginViewSlice = createSlice({
  name: "loginView",
  initialState,
  reducers: {
    setLoginView: (state, action) => {
      state.loginView = action.payload;
    },
    resetLoginView: (state) => {
      state.loginView = "login";
    },
  },
});

export const { setLoginView, resetLoginView } = loginViewSlice.actions;
export const selectLoginView = (state) => state.loginView.loginView;

export default loginViewSlice.reducer;
